<script setup lang="ts">
import { useZoomBuildingImage } from '@/composables/buildingDetails/useZoomBuildingImage'
import IconButton from '../menu/IconButton.vue'

const zoomBuildingImage = useZoomBuildingImage()

/**
 * モーダルを閉じる
 **/
const closeModal = (): void => {
  zoomBuildingImage.close()
}
</script>

<template>
  <div v-if="zoomBuildingImage.isOpen.value">
    <div class="zoom-image-modal">
      <icon-button :icon="['fas', 'fa-square-xmark']" @click="closeModal"></icon-button>
      <img class="zoom-image" :src="zoomBuildingImage.imageUrl.value" />
    </div>
  </div>
</template>
<style scoped>
.zoom-image-modal {
  margin: 80px 0 auto;
  max-width: 80%;
  background-color: white;
  padding: 10px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  border: 1px solid #ccc;
}
.zoom-image {
  height: 80vh;
  width: 100%;
  object-fit: contain;
  padding-top: 10px;
}
</style>
